import { HIDELIST_CONTRACTS } from '../../constants/hidelist-contracts';
import { INFT } from '../../types/nft';
import { Network, Alchemy } from 'alchemy-sdk';
import { getAlchemyApiKey } from '../../constants/connectors';

export type AlchemyApiGetByWalletProps = (
  account: string,
  assetCallback: (assets: INFT[]) => void,
  chainId?: number,
  pageKey?: string,
) => Promise<void>;

export const getNFTsByWallet: AlchemyApiGetByWalletProps = async (
  account,
  assetCallback,
  chainId,
  pageKey = undefined,
): Promise<void> => {
  const alchemyApiKey = getAlchemyApiKey(chainId);
  const settings = {
    apiKey: alchemyApiKey,
    network: chainId === 1 ? Network.ETH_MAINNET : Network.ETH_GOERLI,
    pageKey,
  };
  const alchemy = new Alchemy(settings);
  alchemy.nft
    .getNftsForOwner(account)
    .then((data) => {
      if (data.ownedNfts.length > 0) {
        assetCallback(
          data.ownedNfts
            .filter(
              (nft) =>
                // filter NFTs created with OS collection manager, reason - https://github.com/niftyhorde/swap-kiwi-frontend/issues/202
                !HIDELIST_CONTRACTS.includes(nft.contract.address),
            )
            .map(
              (nft): INFT => {
                return {
                  id: `${nft.tokenId}-${nft.contract.address}`,
                  contractAddress: nft.contract.address,
                  tokenId: nft.tokenId,
                  name: nft.title,
                  issuer: nft.contract.name,
                  imgUrl: nft?.media[0]?.gateway || '',
                  amount: nft.balance.toString(),
                  openseaUrl: `https://${chainId !== 1 ? 'testnets.' : ''}opensea.io/assets/ethereum/${
                    nft.contract.address
                  }/${nft.tokenId}`,
                  type: nft.tokenType,
                };
              },
            ),
        );
        // recursively call this function to get the next batch of nfts offsetting the previous amount
        if (data.pageKey) {
          getNFTsByWallet(account, assetCallback, chainId, data.pageKey);
        } else assetCallback([]);
      } else {
        assetCallback([]);
      }
    })
    .catch((err) => console.log('Alchemy api call failed', err));
};
